/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-27 12:07:34
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-03-27 20:14:07
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Input/BlurTriggerInput.tsx
 */
import React from 'react';

import Input from './Input';

const BlurTriggerInput = (props) => {
  const { onFocus, value, onChange, ...rest } = props;
  const [text, setText] = React.useState(value);
  React.useEffect(() => {
    if (value !== text) {
      setText(value);
    }
  }, [value]);
  const handleOnChange = () => {
    if (onChange) onChange(text);
  };
  return (
    <Input
      onFocus={onFocus}
      onChange={setText}
      value={text}
      onBlur={handleOnChange}
      {...rest}
    />
  );
};
export default BlurTriggerInput;
